export default {"src":"/_next/static/media/carOutlinePatch_64.f6a7801d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};